import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button } from "reactstrap";
import { SwitchToggle } from "../../../Components/TableHelper";
import { useFormik } from "formik";
import axiosInstance from "../../../axiosInterceptor";
import { toast } from "react-toastify";
import Breadcrumb from "../../../Components/Breadcrumb";
import { Eye, EyeOff } from "lucide-react";
import { userSchema } from "../../../Validation/Validation";
const AddUser = () => {
  const navigator = useNavigate();
  const location = useLocation();
  const editData = location.state;
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const editingId = editData?._id;
  const initalvalues = {
    fullName: editData?.fullName,
    email: editData?.email || "",
    password: editData?.password || "",
  };
  const {
    values,
    errors,
    handleChange,
    handleSubmit,
    setFieldValue,
    touched,
    handleBlur,
  } = useFormik({
    initialValues: initalvalues,
    validationSchema: userSchema,
    onSubmit: async (values) => {
      setLoading(true);
      try {
         const payload = { ...values };
    if (editingId) {
      delete payload.password;
    }
        const response = editingId
          ? await axiosInstance.put(`/user/updateuser/${editingId}`, payload)
          : await axiosInstance.post("/user/createuser", values);

        if (response.status === 200) {
          toast.success(response.data.message);
          navigator("/users");
        }
      } catch (error) {
        toast.error(error.response?.data?.message);
        return error;
      } finally {
        setLoading(false);
      }
    },
  });

  const breadcrumbdata = [
    { label: "Home", path: "/dashboard" },
    { label: "user", path: "/user" },
    { label: editingId ? "Update" : "Add", path: "*" },
  ];
const colSize=editingId ?'col-md-6':'col-md-4';
  return (
    <>
      <div className="content-wrapper">
        <div className="page-header mb-3">
          <h3 className="custom-page-title">
            {editingId ? "Update" : "Add"} User
          </h3>
          <Breadcrumb items={breadcrumbdata} />
        </div>
        <div className="col-md-12 grid-margin stretch-card p-0">
          <div className="card m-0">
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className={colSize}>
                    <div className="form-group">
                      <label htmlFor="userName" className="col-form-label ">
                        Full Name
                      </label>
                      <input
                        type="text"
                        className={`form-control border-dark`}
                        id="fullName"
                        name="fullName"
                        placeholder="Enter Full Name"
                        value={values.fullName || ""}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {touched.fullName && errors.fullName && (
                        <small className="text-danger">{errors.fullName}</small>
                      )}
                    </div>
                  </div>

                  <div className={colSize}>
                    <div className="form-group">
                      <label htmlFor="email" className="col-form-label ">
                        Email
                      </label>
                      <input
                        type="text"
                        className={`form-control border-dark`}
                        id="email"
                        name="email"
                        placeholder="Enter Email"
                        value={values.email || ""}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {touched.email && errors.email && (
                        <small className="text-danger">{errors.email}</small>
                      )}
                    </div>
                  </div>

               {
                !editingId && (
                  <div className={colSize}>
                    <div className="form-group">
                      <label htmlFor="password" className="col-form-label">
                        Password
                      </label>

                      <div className="position-relative">
                        <input
                          type={showPassword ? "text" : "password"}
                          className="form-control border-dark pe-5"
                          id="password"
                          name="password"
                          placeholder="Enter Password"
                          value={values.password || ""}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />

                        <span
                          onClick={() => setShowPassword(!showPassword)}
                          style={{
                            position: "absolute",
                            right: "12px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            color: "#6c757d",
                          }}
                        >
                          {showPassword ? (
                            <EyeOff
                              size={20}
                              strokeWidth={1.8}
                              color="#003C1F"
                            />
                          ) : (
                            <Eye size={20} strokeWidth={1.8} color="#000" />
                          )}
                        </span>
                      </div>

                      {touched.password && errors.password && (
                        <small className="text-danger">{errors.password}</small>
                      )}
                    </div>
                  </div>
                )
               }
                </div>

                <div className="text-center mt-4">
                  <Button type="submit" color="primary" disabled={loading}>
                    {loading ? (
                      <span className="d-inline-flex align-items-center gap-2">
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Processing...
                      </span>
                    ) : (
                      "Save"
                    )}
                  </Button>

                  <Link to="/users">
                    <Button color="danger mx-2">Cancel </Button>
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddUser;
